import anime, {AnimeTimelineInstance} from 'animejs'

import {Component} from 'lowkey-component';
import {MediaQuery} from '@services/MediaQuery'
import {WindowService} from '@services/WindowService'

export class ServiceFeatures extends Component {

  mq = MediaQuery.create()
  window = WindowService.create()
  observer: IntersectionObserver | null = null
  itEducation: HTMLDivElement | null = null
  engineerHr: HTMLDivElement | null = null
  advancedTech: HTMLDivElement | null = null
  sticky: HTMLDivElement | null = null
  images: HTMLDivElement[] = []
  tl: AnimeTimelineInstance | null = null
  initialTop = 0

  constructor(element: HTMLDivElement) {
    super(element)
    this.onIntersection = this.onIntersection.bind(this)
    this.onScroll = this.onScroll.bind(this)
    this.onResize = this.onResize.bind(this)
  }

  onResize() {
    const {top} = this.element.getBoundingClientRect()
    this.initialTop = top + window.scrollY
    this.element.style.height = `${this.getHeight()}px`
  }

  getHeight() {
    const {height: itEducationHeight = 0} = this.itEducation?.getBoundingClientRect() || {}
    const {height: engineerHrHeight = 0} = this.engineerHr?.getBoundingClientRect() || {}
    const {height: advancedTechHeight = 0} = this.advancedTech?.getBoundingClientRect() || {}
    return itEducationHeight + engineerHrHeight + advancedTechHeight
  }

  didMount() {
    if (this.mq.isPhone()) {
      return
    }

    this.window.onResize.connect(this.onResize)

    this.observer = new IntersectionObserver(this.onIntersection, {
      rootMargin: '0px',
      threshold: [0, 1],
    })
    this.observer.observe(this.element)

    this.sticky = this.element.querySelector('.p-service_sticky') as HTMLDivElement
    this.itEducation = this.element.querySelector('.s-it-education') as HTMLDivElement
    this.engineerHr = this.element.querySelector('.s-engineer-hr') as HTMLDivElement
    this.advancedTech = this.element.querySelector('.s-advanced-tech') as HTMLDivElement

    this.images =  [...this.element.querySelectorAll('.p-service_image')] as HTMLDivElement[]

    this.tl = anime.timeline({
      easing: 'easeOutExpo',
      autoplay: false,
    })

    const items = this.images
    const [item] = this.images
    item.style.opacity = '1'
    item.style.transform = 'scale(1)'
    items.map((item, index) => {
      const isFirst = index === 0
      const isLast = index === items.length - 1
      this.tl?.add({
        duration: isLast ? 4000 : 10000,
        // duration: 10000,
        targets: item,
        opacity: isFirst ? 1 : [0, 1],
        // translateY: isFirst ? 0 : [30, 0],
        scale: isFirst ? 1 : [1.1, 1],
      }, '-=2000')
      if (!isLast) {
        this.tl?.add({
          easing: 'easeOutSine',
          duration: 3000,
          targets: item,
          opacity: 0,
          // translateY: -30,
        })
      }
    })


    setTimeout(() => {
      this.onResize()
    }, 100);
  }

  didUnmount() {
    this.disable()
    this.observer?.disconnect()
  }

  onIntersection(entries: IntersectionObserverEntry[]) {
    for (const entry of entries) {
      if (!entry.rootBounds) return
      const isDisabled = !entry.isIntersecting
      if (isDisabled) {
        this.disable()
      } else {
        this.enable()
      }
    }
  }

  onScroll() {
    const {top = 0} = this.sticky?.getBoundingClientRect() || {}
    const offsetTop = top + window.scrollY

    const deltaY = offsetTop - this.initialTop

    const max = this.getHeight() - window.innerHeight
    const per = deltaY / max
    this.tl?.seek(this.tl?.duration * per)
  }

  enable() {
    window.addEventListener('scroll', this.onScroll)
  }

  disable() {
    window.removeEventListener('scroll', this.onScroll)
  }

}
